import { createFileRoute, redirect } from "@tanstack/react-router";
import { WarehouseOrdersClient } from "@/features/warehouseOrders/WarehouseOrdersClient";
import { hasModule, firstAllowedRoute } from "@/lib/auth";

// Transport → Magazijnorders (docs/partner-portal.md §16 step 8): the customers' uitleveringen and aanleveringen for a
// warehouse in Scoretrace. Order entry: tms_orders to read, tms_orders_write to type one and to send one again.
export const Route = createFileRoute("/_shell/warehouse-orders")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "tms_orders") && !hasModule(context.session, "tms_orders_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  // ?open=<id>: a warehouse order opened from its dossier.
  validateSearch: (search: Record<string, unknown>): { open?: string } => ({
    open: typeof search.open === "string" && search.open ? search.open : undefined,
  }),
  component: WarehouseOrdersScreen,
});

function WarehouseOrdersScreen() {
  const { session } = Route.useRouteContext();
  const search = Route.useSearch();
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Warehouse Orders">
      <WarehouseOrdersClient userId={session.userId} canWrite={hasModule(session, "tms_orders_write")} initialOpen={search.open ?? null} />
    </div>
  );
}
